import React from 'react';
import { profile } from '../data/profile';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container hero-grid">
        <div>
          <p className="kicker">Portfolio · {profile.location}</p>
          <h1 className="hero-title">
            <span>Tasnia Anower</span>
            <span>Medha</span>
          </h1>
          <p className="hero-role">{profile.role}</p>
          <p className="hero-summary">{profile.headline}</p>
          <div className="hero-actions">
            <a className="btn" href="#work">
              Selected work
            </a>
            <a
              className="btn btn-ghost"
              href={profile.links.resume}
              download={profile.links.resumeName}
              type="application/pdf"
            >
              Download CV
            </a>
            <a className="btn btn-ghost" href="#contact">
              Contact
            </a>
          </div>
          <ul className="hero-meta">
            <li>
              Now · {profile.current.role} at {profile.current.company}
            </li>
            <li>MERN, mobile, and release quality</li>
            <li>2+ years in production</li>
          </ul>
        </div>
        <div className="portrait-wrap">
          <img
            className="portrait"
            src="/images/profile-image.jpg"
            alt="Portrait of Tasnia Anower Medha"
          />
          <div className="portrait-caption">
            <span>Tasnia Anower Medha</span>
            <span>IUT · Software Engineering</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
